export const nameof = <T>(name: Extract<keyof T, string>) => name;
